import { useState, useEffect } from "react";

type TResult = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalSecondsLeft: number;
};

const calculateTimeDiff = (
  startTime: Date,
  endTime: Date,
  reverse?: boolean
) => {
  const timeDiff: number = reverse
    ? startTime.getTime() - endTime.getTime()
    : endTime.getTime() - startTime.getTime();

  return {
    days: Math.floor(timeDiff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((timeDiff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((timeDiff / 1000 / 60) % 60),
    seconds: Math.floor((timeDiff / 1000) % 60),
    totalSecondsLeft: Math.floor(timeDiff / 1000),
  };
};

const useCountdown = (
  endTime: string | undefined,
  reverse?: boolean
): TResult => {
  const initialTimeLeft = calculateTimeDiff(
    new Date(),
    new Date(endTime || new Date()),
    reverse
  );
  const [timeLeft, setTimeLeft] = useState<TResult>(initialTimeLeft);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const end = new Date(endTime || new Date());
      const now = new Date();
      const diff = calculateTimeDiff(now, end, reverse);

      if (diff.totalSecondsLeft >= 0) {
        setTimeLeft(calculateTimeDiff(now, end, reverse));
      }
    };

    const timeOutCountdown = setTimeout(() => calculateTimeLeft(), 1000);

    return () => clearTimeout(timeOutCountdown);
  }, [timeLeft, endTime, reverse]);

  return timeLeft;
};

export default useCountdown;
